// Orders this browser tab is currently updating. The server broadcasts
// "order-status-changed" to every screen (this one included, often before the
// HTTP reply arrives), so this lets a screen tell its own change apart from a
// change made on another device — even when both use the same login.
const inFlight = new Set();

export async function trackOrderUpdate(orderId, request) {
  inFlight.add(orderId);
  try {
    return await request();
  } finally {
    // Keep it briefly so a late broadcast is still recognised as ours
    setTimeout(() => inFlight.delete(orderId), 3000);
  }
}

export const isOwnOrderUpdate = (orderId) => inFlight.has(orderId);
